import{goerli as i,mainnet as s}from"../../../../@wagmi/chains/dist/index.js";import{defineChain as o}from"../utils/chain.js";const t=o(i),a=o(s);export{t as goerli,a as mainnet};
